import React from 'react';

import AddEditComment from './AddEditComment';
import CommentSection from './CommentSection';

interface CommentProps {
  value: string;
  isDisabled: boolean;
  handleEdit?: () => void;
}

const Comment = ({ value, isDisabled, handleEdit }: CommentProps) => {
  return !!handleEdit ? (
    <AddEditComment value={value} isDisabled={isDisabled} onEdit={handleEdit} />
  ) : (
    <CommentSection value={value} />
  );
};

export default Comment;
